import {SpanIcon} from '@mazraeapp/react_icon_kit';
import React from 'react';
import {useNavigate} from 'react-router-dom';
interface BackTitleHeaderProps {
  title: string;
}
const BackTitleHeader = ({title}: BackTitleHeaderProps) => {
  const navigate = useNavigate();
  return (
    <header>
      <div className="flex shadow-sm  text-md text-gray-800 h-[56px] bg-white px-4 w-full justify-between items-center">
        <div onClick={() => navigate(-1)}>
          <SpanIcon className="icon-nameArrow---Right text-[25px] text-gray-700" />
        </div>
        <div>{title}</div>
        <div></div>
      </div>
    </header>
  );
};

export default BackTitleHeader;
